export const locale = {
    lang: "en-US",
    data: {
        TOOLBAR: {
            CHANGE_PASSWORD: "Change Password",
            LOGOUT: "Logout",
            HELP: "Help"
        }
    }
};
